import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useFormik } from "formik";
import SignatureCanvas from "react-signature-canvas";
import axiosInstance from "../../../../../Services/axiosCommon";
import { useToast } from "../../../../../Components/Others/ToastServices";
import { NuFormSelect, NuInput, NuInputfile, NuTableFormSelect, NuTextArea } from "../../../../../Components/Utils/Input";
import Attachement from "../../../../../Components/Utils/CustomAttrachmentupload";
import { BackButton, SubmitButton } from "../../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";
import { SecondHeading } from "../../../../../Components/Utils/Heading";
import Print from "../../../../../Components/Icons/Print";

import List from "../../../../../Components/Icons/list";
import Card from "../../../../../Components/Icons/card";

function NewViewSur() {
  const { viewIdsurvey } = useParams();
  const location = useLocation();
  const [data, setData] = useState({});
  const [viewMode, setViewMode] = useState("normal");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [flattenedQuestions, setFlattenedQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const toast = useToast();

  const clientSigCanvas = useRef(null);
  const collectorSigCanvas = useRef(null);

  function getView() {
    setIsLoading(true);
    axiosInstance
      .get(`/form/${viewIdsurvey}`)
      .then((res) => {
        const formData = res.data?.data;
        setData(formData);
        const questions =
          formData?.titles?.flatMap((title) =>
            title.fields.map((field) => ({
              ...field,
              titleName: title.titleName,
            }))
          ) || [];
        setFlattenedQuestions(questions);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching form data:", err);
        toast.open({ type: "error", message: "Failed to fetch form data" });
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getView();
  }, [viewIdsurvey]);

  useEffect(() => {
    setCurrentQuestionIndex(0);
  }, [viewMode]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        formData.append("json_data", JSON.stringify(values));

        if (clientSigCanvas.current && !clientSigCanvas.current.isEmpty()) {
          const clientSig = clientSigCanvas.current
            .getTrimmedCanvas()
            .toDataURL("image/png");
          formData.append("clientSignature", clientSig);
        }
        if (
          collectorSigCanvas.current &&
          !collectorSigCanvas.current.isEmpty()
        ) {
          const collectorSig = collectorSigCanvas.current
            .getTrimmedCanvas()
            .toDataURL("image/png");
          formData.append("collectorSignature", collectorSig);
        }

        files.forEach((fileObj) => {
          formData.append("attachments", fileObj.file);
        });

        await axiosInstance.post(`/form/${viewIdsurvey}/submit`, formData);
        toast.open({ type: "success", message: "Form submitted successfully" });
        resetForm();
        setFiles([]);
        clientSigCanvas.current?.clear();
        collectorSigCanvas.current?.clear();
      } catch (err) {
        console.error("Error submitting form:", err);
        toast.open({ type: "error", message: "Failed to submit form" });
      }
    },
  });
  const clearSignature = (type) => {
    if (type === "client" && clientSigCanvas.current) {
      clientSigCanvas.current.clear();
    } else if (type === "collector" && collectorSigCanvas.current) {
      collectorSigCanvas.current.clear();
    }
  };

  const saveSignature = (type) => {
    if (
      type === "client" &&
      clientSigCanvas.current &&
      !clientSigCanvas.current.isEmpty()
    ) {
      const dataURL = clientSigCanvas.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      toast.open({
        type: "success",
        message: "Client signature saved locally",
      });
      return dataURL;
    } else if (
      type === "collector" &&
      collectorSigCanvas.current &&
      !collectorSigCanvas.current.isEmpty()
    ) {
      const dataURL = collectorSigCanvas.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      toast.open({
        type: "success",
        message: "Collector signature saved locally",
      });
      return dataURL;
    }
    toast.open({ type: "warning", message: "No signature to save" });
    return null;
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleNext = () => {
    if (currentQuestionIndex < flattenedQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleSkip = () => {
    if (currentQuestionIndex < flattenedQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };
  function giveValue(value, formik) {
    switch (value?.field_type) {
      case "text":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "number":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5 text-right">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "string":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.Name}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "yesno":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <input type="checkbox" />
                          </div>
                        </td>
                      );
                    })}
                  {/* {[
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ] &&
                      [
                        { label: "Yes", type: "checkbox" },
                        { label: "No", type: "checkbox" },
                        { label: "N/A", type: "checkbox" },
                      ].map((item, k) => {
                        return (
                          <td key={k}>
                            <div className="flex justify-center items-center gap-2">
                              <p>{item?.label || ""}</p>
                              <InputCheck
                                type={item?.type}
                                formik={formik}
                                placeholder={""}
                                name={item?.label}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex !== index}
                              />
                            </div>
                          </td>
                        );
                      })} */}
                </tr>
              </table>
            </div>
          </>
        );
      case "checkbox":
        return (
          <>
            {/* <div className={`w-full py-2 text-xs mt-5`}>
    <table className="w-full">
      <tr className="">
        <td className="w-2/12">
          <p>{value?.field_label}</p>
        </td>
        {value?.metadata &&
          Object.entries(value?.metadata).map(([key, valueOf]) => (
            <td key={valueOf}>
              <div className="flex flex-row-reverse justify-start items-center gap-2 w-[200px]">
                <InputCheck
                  fullValue={value?.value}
                  label={key}
                  formik={formik}
                  placeholder={""}
                  name={key}
                  id={value?.id}
                  field_type={value?.field_type}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  disabled={editModeIndex !== index}
                />
                <p>{key || ""}</p>
              </div>
            </td>
          ))}
      </tr>
    </table>
  </div> */}
            <div className="w-full py-2 text-xs mt-5">
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="w-2/12 align-top">
                      <p>{value?.field_label}</p>
                    </td>

                    <td className="w-10/12 p-0">
                      <table className="w-full">
                        <tbody>
                          {Array.from({
                            length: Math.ceil(
                              Object.entries(value?.metadata).length / 5
                            ),
                          }).map((_, rowIndex) => {
                            const items = Object.entries(value?.metadata).slice(
                              rowIndex * 5,
                              rowIndex * 5 + 5
                            );
                            const emptyCells = 5 - items.length;

                            return (
                              <tr key={rowIndex}>
                                {Array.from({ length: emptyCells }).map(
                                  (_, i) => (
                                    <td
                                      key={`empty-${i}`}
                                      className="w-1/6 p-2"
                                    ></td>
                                  )
                                )}

                                {value?.metadata &&
                                  Object.entries(value?.metadata).map(
                                    ([key, valueOf]) => (
                                      <td key={valueOf}>
                                        <div className="flex justify-end items-center gap-2 w-[200px]">
                                          <p>{key || ""}</p>
                                          <input type="checkbox" />
                                        </div>
                                      </td>
                                    )
                                  )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        );
      case "single_checkbox":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-2/12">
                    <p>{value?.field_label}</p>
                  </td>
                  {value?.metadata &&
                    Object.entries(value?.metadata).map(
                      ([key, valueOf], idxOne) => (
                        <td key={idxOne} className=" w-1/12 p-2 ">
                          <div className="flex flex-row-reverse justify-start items-center gap-2">
                            <input type="checkbox" />
                            <p>{key || ""}</p>
                          </div>
                        </td>
                      )
                    )}
                </tr>
              </table>
            </div>
          </>
        );
      case "textArea":
        return (
          <>
            <NuTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
            />
          </>
        );
      case "observation":
        return (
          <>
            <NuTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
            />
          </>
        );
      case "date":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs w-full  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "time":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.Name}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "imagePath":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "file":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "table-data":
        return (
          <>
            <div className=" w-full">
              <table className=" w-full  text-xs">
                <thead>
                  <tr>
                    {value?.value &&
                      value?.value.map((item, k) => {
                        return (
                          <th key={k} className="text-left py-2 px-4 ">
                            {item?.label || ""}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {Array(10)
                    .fill(0)
                    .map((_, i) => (
                      <tr key={i}>
                        {value?.value &&
                          value?.value.map((item, k) => {
                            return (
                              <td
                                key={k}
                                className="text-left py-2 px-4  h-8 border"
                              >
                                {""}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        );
      case "multi":
        return (
          <>
            <div className=" w-full">
              {value?.metadata && Object.keys(value?.metadata).length > 3 ? (
                <div className="grid grid-cols-4 gap-2 items-center text-xs  ">
                  <div>{value?.field_label || ""}</div>
                  {Object.entries(value?.metadata).map(([key, valueOf], i) => {
                    return (
                      <>
                        {key == "Comments" ? (
                          <div
                            className=" col-span-3 grid grid-cols-3  "
                            key={i}
                          >
                            <div></div>
                            <div className=" col-span-2 flex items-center justify-end ">
                              <p className="  ">{key || ""}</p>
                              <textarea
                                className="w-5/6 border outline-none border-gray-300 rounded-lg px-3 py-2 my-3"
                                rows={3}
                                label=""
                                placeholder={""}
                                formik={formik}
                                name={value?.field_label}
                                new_width={"w-1/4"}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            {valueOf == "text" ? (
                              <div
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " w-full"
                                    : " w-full"
                                } flex gap-3 items-center ${
                                  (i + 1) % 5 !== 1 ? "text-end" : "text-start "
                                } ${i + 1 === 1 ? "text-end" : ""}  ${
                                  (i + 1) % 4 === 0 && i + 1 !== 1
                                    ? " col-span-2 "
                                    : ""
                                }`}
                                key={i}
                              >
                                {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                  <>
                                    <div className=" w-full flex justify-end items-center gap-2">
                                      <div className=" w-1/2"></div>
                                      <div className=" w-1/2 flex gap-1 items-center">
                                        <p className=" w-1/3 text-xs mr-1.5">
                                          {key || ""}
                                        </p>
                                        <input
                                          label={""}
                                          type={value?.type}
                                          formik={formik}
                                          placeholder={value?.Name}
                                          name={value?.value}
                                          width={"w-full"}
                                          className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p className=" w-1/3 text-xs text-right ">
                                      {key || ""}
                                    </p>
                                    <input
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                      className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                    />
                                  </>
                                )}
                              </div>
                            ) : valueOf == "string" ? (
                              <div className=" w-full text-xs ">
                                <p className=" w-full">{key || ""}</p>
                              </div>
                            ) : valueOf == "yesno" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      {[
                                        {
                                          label: "Yes",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "No",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "N/A",
                                          type: "checkbox",
                                        },
                                      ] &&
                                        [
                                          {
                                            label: "Yes",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "No",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "N/A",
                                            type: "checkbox",
                                          },
                                        ].map((item, k) => {
                                          return (
                                            <td key={k} className=" px-1.5">
                                              <div className="flex justify-center items-center gap-0.5 text-end ">
                                                <p>{item?.label || ""}</p>
                                                <input type="checkbox" />
                                              </div>
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "number" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <input
                                            label={""}
                                            type={value?.type}
                                            formik={formik}
                                            placeholder={value?.Name}
                                            name={value?.value}
                                            width={"w-full"}
                                            className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs text-right">
                                        {key || ""}
                                      </p>
                                      <input
                                        label={""}
                                        type={value?.type}
                                        formik={formik}
                                        placeholder={value?.Name}
                                        name={value?.value}
                                        width={"w-full"}
                                        className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "checkbox" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <input type="checkbox" />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs">
                                        {key || ""}
                                      </p>
                                      <input type="checkbox" />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "truefalse" ? (
                              <>
                                <div className=" w-full flex justify-end items-center gap-2">
                                  <p className=" w-1/3  text-xs text-right">
                                    {key || ""}
                                  </p>
                                  <input type="checkbox" />
                                </div>
                              </>
                            ) : valueOf == "yesnona" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      {[
                                        {
                                          label: "Yes",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "No",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "N/A",
                                          type: "checkbox",
                                        },
                                      ] &&
                                        [
                                          {
                                            label: "Yes",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "No",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "N/A",
                                            type: "checkbox",
                                          },
                                        ].map((item, k) => {
                                          return (
                                            <td key={k} className=" px-1.5">
                                              <div className="flex justify-center items-center gap-0.5 text-end ">
                                                <p>{item?.label || ""}</p>
                                                <input type="checkbox" />
                                              </div>
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "dropdown" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-5/12 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      <td className="px-2">
                                        <NuFormSelect
                                          name={key}
                                          label={key}
                                          placeholder={""}
                                          id={value?.id}
                                          field_type={value?.field_type}
                                          allValue={[]}
                                          setAllValue={() => {}}
                                          disabled={false}
                                          options={[]}
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : (
                              <div className="w-full text-xs ">
                                <p className="">{key || ""}</p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              ) : (
                <>
                  <table className="w-full  ">
                    <tr>
                      {value?.metadata &&
                        Object.entries(value?.metadata).map(
                          ([key, valueOf], idxTwo) => (
                            <>
                              <td
                                key={idxTwo}
                                className=" text-xs  text-end first:text-start"
                              >
                                {valueOf == "text" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuInput
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                    />
                                  </div>
                                ) : valueOf == "number" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuInput
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                    />
                                  </div>
                                ) : valueOf == "string" ? (
                                  <>
                                    <p>{key || ""}</p>
                                  </>
                                ) : valueOf == "yesnona" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>

                                          {[
                                            { label: "Yes", type: "checkbox" },
                                            { label: "No", type: "checkbox" },
                                            { label: "N/A", type: "checkbox" },
                                          ] &&
                                            [
                                              {
                                                label: "Yes",
                                                type: "checkbox",
                                              },
                                              { label: "No", type: "checkbox" },
                                              {
                                                label: "N/A",
                                                type: "checkbox",
                                              },
                                            ].map((item, k) => {
                                              return <input type="checkbox" />;
                                            })}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : valueOf == "yesno" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>

                                          {[
                                            { label: "Yes", type: "checkbox" },
                                            { label: "No", type: "checkbox" },
                                            { label: "N/A", type: "checkbox" },
                                          ] &&
                                            [
                                              {
                                                label: "Yes",
                                                type: "checkbox",
                                              },
                                              { label: "No", type: "checkbox" },
                                              {
                                                label: "N/A",
                                                type: "checkbox",
                                              },
                                            ].map((item, k) => {
                                              return <input type="checkbox" />;
                                            })}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p>{`${key} ${valueOf}` || ""}</p>
                                  </>
                                )}
                              </td>
                            </>
                          )
                        )}
                    </tr>
                  </table>
                </>
              )}
            </div>
          </>
        );
      case "tableRow":
        return (
          <>
            <table className="w-full border border-collapse">
              <tr>
                {/* <td className="w-2/12 text-xs border px-2">
                    <p>{value?.field_label}</p>
                  </td> */}
                {
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idxThree) => {
                        return (
                          <>
                            {valueOf == "text" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border-y px-3`}
                                key={idxThree}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuInput
                                  label={""}
                                  type={value?.type}
                                  formik={formik}
                                  placeholder={value?.Name}
                                  name={value?.value}
                                  width={"w-full"}
                                />
                              </td>
                            ) : valueOf == "date" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border px-3`}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuInput
                                  label={""}
                                  type={value?.type}
                                  formik={formik}
                                  placeholder={value?.Name}
                                  name={value?.value}
                                  width={"w-full"}
                                />
                              </td>
                            ) : value == "string" ? (
                              <td className=" w-full">
                                <p className=" w-full">{key || ""}</p>
                              </td>
                            ) : (
                              <td className="w-full">
                                <p className="">{`${key} ` || ""}</p>
                              </td>
                            )}
                          </>
                        );
                      }
                    )}
                  </>
                }
              </tr>
            </table>
          </>
        );
      case "tableItems":
        return (
          <>
            <table className="w-full border border-collapse  text-xs">
              {Array.isArray(value?.metadata) && value?.metadata.length > 0 ? (
                value?.metadata.map((item, indx) => (
                  <tr key={indx} className=" text-xs">
                    {/* <td className=" w-2/12 border">{value?.label||"-"}</td> */}
                    {Object.entries(item).map(([key, valueOf], idx) => (
                      <td key={idx} className="border py-1 px-2 min-w-[50px] max-w-[250px]">
                        {valueOf == "text" ? (
                          <>
                          <input type="text" className="border px-2 py-2.5 w-full rounded-lg" />
                          </>
                        ) : valueOf == "number" ? (
                          <>
                            <NuInput
                              label={""}
                              type={value?.type}
                              formik={formik}
                              placeholder={value?.Name}
                              name={value?.value}
                              width={"w-full"}
                            />
                          </>
                        ) : valueOf == "legends" ? (
                          <>
                            <NuTableFormSelect
                              label={key}
                              type={"text"}
                              formik={formik}
                              placeholder={value?.Name}
                              name={`${key}${valueOf}${indx}`}
                              width={"w-full"}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={[]}
                              setAllValue={() => {}}
                              disabled={false}
                              idx={indx + 1}
                              options={[
                                {
                                  label: "c",
                                  value: "C",
                                },
                                {
                                  label: "t",
                                  value: "t",
                                },
                                {
                                  label: "o",
                                  value: "o",
                                },
                                {
                                  label: "N",
                                  value: "N",
                                },
                              ]}
                            />
                          </>
                        ) : valueOf == "textArea" ? (
                          <>
                            <NuInput
                              label={""}
                              type={"text"}
                              formik={formik}
                              placeholder={value?.Name}
                              name={value?.value}
                              width={"w-full"}
                            />
                          </>
                        ) : (
                          <>
                            <p>{key || ""}</p>
                          </>
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <td>
                  <p>No Data</p>
                </td>
              )}

              {/* <tr>
                  <td className="w-2/12">
                    <p>{value?.field_label||""}</p>
                  </td>
  
               </tr> */}
            </table>
          </>
        );
      case "yesnona":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <input type="checkbox" />
                          </div>
                        </td>
                      );
                    })}
                </tr>
              </table>
            </div>
          </>
        );
      case "heading":
        return (
          <>
            <div className={` w-full py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.field_label}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "tableHeaders":
        return (
          <table className="w-full border border-collapse">
            <thead>
              <tr>
                {Object.entries(value?.metadata).length > 10 ? (
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idx) => (
                        <th
                          className=" [writing-mode:vertical-lr] max-h-[150px] rotate-180 p-2 text-left min-w-[50px] max-w-[250px] py-2 text-xs border "
                          key={idx}
                        >
                          {key}
                        </th>
                      )
                    )}
                  </>
                ) : (
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idx) => (
                        <th
                          className=" min-w-[150px] max-w-[250px] py-2 text-xs border "
                          key={idx}
                        >
                          {key}
                        </th>
                      )
                    )}
                  </>
                )}
              </tr>
            </thead>
          </table>
        );
      default:
        return <>No</>;
    }
  }

  const renderSignatureAndAttachments = () => (
    <div className="w-full  p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Signature </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
       

        {/* Collector Signature */}
        <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
          {/* <h3 className="text-sm font-semibold text-gray-600 mb-2">Collector </h3> */}
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              className: "border border-gray-400 w-full h-40 rounded-md",
            }}
            ref={collectorSigCanvas}
          />
          <div className="flex justify-between items-center mt-3">
            <span className="text-xs font-semibold text-gray-500">
              Collector
            </span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => clearSignature("collector")}
                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
              >
                Clear
              </button>
              <button
                type="button"
                // onClick={() => saveSignature("collector")}
                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>

         {/* Client Signature */}
        <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
          {/* <h3 className="text-sm font-semibold text-gray-600 mb-2">Client </h3> */}
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              className: "border border-gray-400 w-full h-40 rounded-md",
            }}
            ref={clientSigCanvas}
          />
          <div className="flex justify-between items-center mt-3">
            <span className="text-xs font-semibold text-gray-500">Client</span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => clearSignature("client")}
                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
              >
                Clear
              </button>
              <button
                type="button"
                onClick={() => saveSignature("client")}
                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Attachments */}
      <div className="w-full mt-8">
        <h3 className="text-sm font-semibold text-gray-600 mb-4">
          Attachments
        </h3>
        <Attachement
          handleChange={handleFileChange}
          disabled={false}
          preview={files.map((f) => f.preview)}
          width="w-full"
          label="Attach Files"
          multiple={true}
          removeImages={removeFile}
          className="border border-gray-300 rounded-lg p-4 bg-white shadow-sm"
        />
      </div>
    </div>
  );

  // Normal View
  const renderNormalView = () => (
    <form onSubmit={formik.handleSubmit}>
      <div className="w-full h-[calc(100vh-165px)] bg-white rounded-md mt-4 overflow-y-auto px-4 py-4">
        <SecondHeading className="text-xl">
          {data?.formName || "Untitled Form"}
        </SecondHeading>
        <div>
          {data?.titles &&
            data.titles.map((item, i) => (
              <div key={i} className="mb-4">
                <div className="w-full flex justify-between items-center bg-baseColor-primary border-y border-baseColor-primary">
                  <p className="py-3 px-3 text-sm 2xl:text-base font-semibold text-white">
                    {item.titleName || "Untitled Section"}
                  </p>
                </div>
                <div className="w-full flex flex-wrap justify-start items-start py-2 px-4">
                  {item?.fields &&
                    item.fields.map((subItem, j) => (
                      <div
                        key={j}
                        className="w-full border-b border-gray-300 py-2"
                      >
                        {giveValue(subItem, formik)}
                      </div>
                    ))}
                </div>
              </div>
            ))}
        </div>
        {renderSignatureAndAttachments()}
        {/* <div className="flex justify-end mt-6">
          <SubmitButton isLoading={formik.isSubmitting} />
        </div> */}
      </div>
    </form>
  );

  // Card View
  const renderCardView = () => {
    // if (isLoading) {
    //   return (
    //     <div className="flex justify-center items-center h-[calc(100vh-145px)]">
    //       <p className="text-gray-500 text-center">Loading...</p>
    //     </div>
    //   );
    // }
    if (flattenedQuestions.length === 0) {
      return (
        <p className="text-center text-gray-500">No questions available.</p>
      );
    }

    // Show signatures and attachments if at the last question
    const isLastQuestion = currentQuestionIndex === flattenedQuestions.length;

    return (
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full h-[calc(100vh-165px)] rounded-md mt-4 overflow-hidden flex flex-col items-center">
          <div className="border border-baseColor-primary rounded-lg w-full h-[calc(100vh-165px)] md:w-[60%] bg-white shadow-lg flex flex-col overflow-hidden">
            {/* Heading */}
            <h1 className="text-2xl font-bold text-white bg-baseColor-primary py-3 px-6">
              {data?.formName || "Untitled Form"}
            </h1>

            {/* Content */}
            <div className="flex-1 w-full overflow-y-auto py-6 px-8">
              {!isLastQuestion ? (
                <>
                  {/* Question Title */}
                  <h2 className="text-xl font-semibold text-gray-800 mb-4">
                    {flattenedQuestions[currentQuestionIndex].titleName ||
                      "Untitled Section"}
                  </h2>
                  <p className="text-sm text-blue-500 mb-4">
                    Question {currentQuestionIndex + 1} of{" "}
                    {flattenedQuestions.length}
                  </p>
                  <h3 className="text-lg font-medium text-gray-700 mb-6">
                    {flattenedQuestions[currentQuestionIndex].field_label ||
                      "No Label"}
                  </h3>

                  {/* Fields */}
                  <div className="w-full overflow-y-scroll">
                    {giveValue(
                      flattenedQuestions[currentQuestionIndex],
                      formik,
                      true
                    )}
                  </div>
                  {/* {flattenedQuestions.length === flattenedQuestions.length &&(
            {renderSignatureAndAttachments()})} */}
                </>
              ) : (
                <>
                  <div className="w-full bg-baseColor-primary h-2 rounded-full mb-6">
                    <div
                      className="bg-baseColor-primary h-2 rounded-full"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                </>
              )}
            </div>

            {/* Footer Buttons */}
            <div className="border-t p-4 flex justify-between items-center gap-2 bg-white sticky bottom-0">
              {!isLastQuestion ? (
                <>
                  <button
                    type="button"
                    onClick={handlePrevious}
                    disabled={currentQuestionIndex === 0}
                    className={`px-6 py-2 rounded-md text-sm font-semibold transition ${
                      currentQuestionIndex === 0
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-baseColor-primary text-white hover:bg-baseColor-primary"
                    }`}
                  >
                    Previous
                  </button>

                  <div className="flex gap-2 ml-auto">
                    <button
                      type="button"
                      onClick={handleSkip}
                      disabled={
                        currentQuestionIndex === flattenedQuestions.length - 1
                      }
                      className={`px-6 py-2 rounded-md text-sm font-semibold transition ${
                        currentQuestionIndex === flattenedQuestions.length - 1
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-yellow-400 text-yellow-800 hover:bg-yellow-500"
                      }`}
                    >
                      Skip
                    </button>
                    <button
                      type="button"
                      onClick={handleNext}
                      disabled={
                        currentQuestionIndex === flattenedQuestions.length - 1
                      }
                      className={`px-6 py-2 rounded-md text-sm font-semibold transition ${
                        currentQuestionIndex === flattenedQuestions.length - 1
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-baseColor-primary text-white hover:bg-baseColor-primary"
                      }`}
                    >
                      Next
                    </button>
                  </div>
                </>
              ) : (
                <div className="flex justify-end w-full">
                  <SubmitButton isLoading={formik.isSubmitting} />
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="w-full h-full py-6 px-4 bg-gray-100">
      <div className="sm:flex justify-between items-center mb-4">
        <Breadcrumb
         items={[ 
              { name: "Form" },
            { name: "View" }
          
          ]}
        />
        <div className="flex items-center gap-2 justify-end">
          <button
            type="button"
            onClick={() => setViewMode("normal")}
            className={`p-2 rounded-lg transition ${
              viewMode === "normal"
                ? "bg-baseColor-primary text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            <List className="w-5 h-5" />
          </button>
          <button
            type="button"
            onClick={() => setViewMode("card")}
            className={`p-2 rounded-lg transition ${
              viewMode === "card"
                ? "bg-baseColor-primary text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            <Card className="w-5 h-5" />
          </button>

          <button
            type="button"
            className={`p-2 rounded-lg transition bg-gray-200 text-gray-700 hover:bg-gray-300`}
          >
            <Print className="w-5 h-5" />
          </button>
          <Link
            to="/forms"
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery || "",
            }}
          >
            <BackButton />
          </Link>
        </div>
      </div>
      {viewMode === "normal" ? renderNormalView() : renderCardView()}
    </div>
  );
}

export default NewViewSur;
